/* APP */
import "popper.js";
import "bootstrap";
import "@fortawesome/fontawesome-pro/js/all";
import "./wad-payment.js";

/* WADCMS
A décommenter si vous utilisez WadCms */
/* import '../../vendor/wad-commons/wad-cms/assets/js/app-cms'; */

/* WADGALLERY
A décommenter si vous utilisez WadGallery */
/* import '../../vendor/wad-commons/wad-gallery/assets/js/app-gallery'; */

/* GMAP
A décommenter si vous utilisez une Google Map */
/* import { Gmap } from './map'; */

import './register';
import './workshop';
import './submit-workshop';
//import './qualiopi';
import '../../node_modules/lightbox2/dist/js/lightbox.min';


$(document).ready(() => {
  window.FontAwesomeConfig = {
    searchPseudoElements: true
  };
});

import videojs from "video.js";

$(document).ready(function() {
  // Keep alive (server status)
  checkStreamAccess();
  let status = setInterval(checkStreamAccess, 3000);

  function checkStreamAccess() {
    let dataTag = document.getElementById('data');
    if (dataTag) {
      let data = JSON.parse(dataTag.innerHTML);
      $.ajax({
        url: data.checkUrl,
        type: 'get',
        dataType: 'json',
        cache: 'false',
        timeout: 1000,
        success: function (data) {
          statusUpdate(data.status);
          //clearInterval(status);
        },
        error: function (jqXHR, textStatus, error) {
          statusUpdate(false);
        },
      });
    } else {
      $('#streaming-on').removeClass('d-none');
      $('#streaming-off').addClass('d-none');
    }
  }

  function statusUpdate(status) {
    if (status) {
      $('#streaming-on').removeClass('d-none');
      $('#streaming-off').addClass('d-none');

    } else {
      $('#streaming-on').addClass('d-none');
      //$('#streaming').player().reset();
      videojs('streaming').pause();
      videojs('streaming').initChildren();
      $('#streaming-off').removeClass('d-none');

    }
  }

  $('.enter-fullscreen').click(function(e) {
    e.preventDefault();
    $('.vjs-play-control').click();
    $('.vjs-fullscreen-control').click();
  });

});
